module.exports = "<div class=\"usc-nav-bar\"></div>\n<div class=\"warning\">We are currently initializing the Plan to Win Data. Please check back later.</div>"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-p2w-waiting/usc-p2w-waiting.component.html
// module id = ../../../../../src/app/components/usc-store/usc-p2w-waiting/usc-p2w-waiting.component.html
// module chunks = main